import {createContext, useContext} from 'react';

export interface ScreenshotContextType {
  captureScreenshot: () => Promise<string | null>,
//   generateThumbnail: (imageData: string, maxWidth: number) => Promise<string>,
//   convertToFormData: (imageData: string, fileName?: string) => Promise<FormData>,
//   downloadScreenshot: (imageData: string, fileName?: string) => void,
}

const defaultContextValue: ScreenshotContextType = {
    captureScreenshot: () => Promise.resolve(null),
    // generateThumbnail: () => Promise.resolve(''),
    // convertToFormData: () => Promise.resolve(new FormData()),
    // downloadScreenshot: () => {},
};

export const ScreenshotContext = createContext<ScreenshotContextType>(defaultContextValue);
export const useScreenshot = () => useContext(ScreenshotContext);
